import React, { Component, useState, useEffect, useRef } from 'react';
import { SimulatorModel } from './models/SimulatorModel'
import { Offer } from './_Offer'
import OfferProduction from './production/_OfferProduction'
import { LeadsPageModel, SimulatorPageModel, SimulatorOfferModel, RiderPackageModel } from './models/superbit-api-models'

import { SuperBit_swaggerClient } from './models/superbit-api-models'
import { StatOptions } from 'fs';
import { Menu } from './_Menu'
import Header from './Header';
import Footer from './_Footer'
import { SimulatorSidebar } from './_SimulatorSidebar'
import './assets/css/simulator_p0002.css?a=1'
import './assets/css/simulator.css'
import './assets/css/_simple-popup.css'
import LoginStatus from './login/_LoginStatus';
import LoginPopup from './login/_LoginPopUp';
import { Spin } from 'antd';
import PleaseWaitLayer from './components/_PleaseWaitLayer';
import { RenewalsModel } from './models/RenewalsModel';
import { RenewalOffer } from './offers/_RenewalOffer';

type Props = {
  leadId: string,
  offerId: string
  location?: any;
};
type State = {
  data: SimulatorPageModel | null;
  name: string;
  filterOpen: boolean;
  offers: SimulatorOfferModel[];
  renewalOffer: SimulatorOfferModel | undefined,
  renewalRiders: RiderPackageModel[];
  riders: RiderPackageModel[];
  loadingOffers: boolean;
  logData: string;
  copied: boolean;
  productionOffer: SimulatorOfferModel | null;
  propductionRiders: RiderPackageModel[];
  loaded: boolean;
  sortField: string;
  sortType: string;
  loggedUser: any | null;
  loadOffersBussy: boolean;
  userLogged: boolean;
};

export class Simulator extends Component<Props, State> {
  private sideBarRef: React.RefObject<SimulatorSidebar>;

  state: State = {
    data: null,
    name: "Simulator",
    filterOpen: true,
    offers: [],
    renewalOffer: undefined,
    riders: [],
    renewalRiders: [],
    loadingOffers: false,
    logData: "",
    copied: false,
    productionOffer: null,
    propductionRiders: [],
    loaded: false,
    sortField: "",
    sortType: "",
    loggedUser: null,
    loadOffersBussy: false,
    userLogged: false
  };

  selectedLeadId = '';
  selectedVehicleNumber = '';

  hideFilterClick() {
    this.setState(prevState => ({
      filterOpen: !prevState.filterOpen
    }));

  };


  constructor(props: Props, state: State) {
    super(props);
    this.sideBarRef = React.createRef<SimulatorSidebar>();
    this.loadOffers = this.loadOffers.bind(this);
  }

  componentDidMount() {
    let loggedUser: any = localStorage.getItem('loggedUser');
    if (loggedUser) {
      loggedUser = JSON.parse(loggedUser);
      this.setState({ loggedUser })
    }
    this.load();
  }

  async load() {
    if (this.state.loaded || this.selectedLeadId != '') {
      return;
    }
    try {

      let leadId = localStorage.getItem('leadId');
      if (leadId === null) {
        leadId = '';
      } else {
        this.selectedLeadId = leadId;
        const leadVehicleNumber = localStorage.getItem('leadVehicleNumber');
        if (leadVehicleNumber != null) {
          this.selectedVehicleNumber = leadVehicleNumber;
        }
        else {
          this.selectedVehicleNumber = '';
        }
      }
      if (this.props.leadId && this.props.leadId != '') {
        leadId = this.props.leadId;

      }
      localStorage.removeItem('leadId');
      const model = await new SimulatorModel().getSimulator((this.selectedLeadId as string), this.props.offerId);
      if (model.lead.offers && model.lead.offers.length > 0) {
        this.setState({ renewalOffer: model.lead.offers[0] });
        var riders = await new RenewalsModel().getRiders(model.lead.offers[0].vehicleId);
        this.setState({ renewalRiders: riders });
      }
      //console.log('model', model);
      if (this.selectedVehicleNumber !== '') {
        model.lead.vehicle.licenseNumber = this.selectedVehicleNumber;
      }
      this.setState({
        data: model,
        name: "Sara",
        loaded: true
      })
    } catch (error) {

    }

  };

  loadRiders = (riders: RiderPackageModel[]) => {
    var _riders = this.state.riders;
    // if(_riders.length==0)
    // {
    //   _riders = riders;
    // }
    _riders = riders;

    this.setState({ riders: _riders });
  }


  updateOffer = async (offer: SimulatorOfferModel) => {
    var offers = this.state.offers;
    offers = offers.filter(x => x != null);
    await this.setState({ offers: offers });
    // 
    //Find index of specific object using findIndex method.  
    if (offer != null && offer.id != null) {
      var objIndex = offers.findIndex((obj => obj.id == offer.id));
      offers[objIndex] = offer;
      await this.setState({ offers: offers });
    }

  }

  openProduction = (offer: SimulatorOfferModel, riders: RiderPackageModel[]) => {
    this.setState({ productionOffer: offer });
    this.setState({ propductionRiders: riders });
  }

  closeProduction = () => {

    this.setState({ productionOffer: null });


  }

  updateRiders = (riders: RiderPackageModel[]) => {
    this.setState({ riders: riders });
  }

  showOfferLog = (log: string) => {

    log = log.replaceAll("&amp;", "&").replaceAll("&lt;", "<").replaceAll("&gt;", ">").replaceAll("&lt;", "<");
    this.setState({ logData: log });
    this.setState({ copied: false });
  }
  clearOfferLog = () => {
    this.setState({ logData: "" });
  }

  copyToClipboard = async () => {
    var log = this.state.logData;
    await navigator.clipboard.writeText(log);
    this.setState({ copied: true });

  }

  loadOffers = async (offers: SimulatorOfferModel[]) => {
    // while(this.state.loadOffersBussy){}
    const currentOffers = this.state.offers || [];

    this.setState({ offers: [] }, () => {
      this.setState({ loadOffersBussy: true });
    });
    const filteredOffers = offers.filter(x => x != null);


    // Create a new array to ensure immutability
    const newOffers = [...currentOffers, ...filteredOffers];
    // //console.log('loadOffers sort', newOffers.length, newOffers)
    // Sort the offers in descending order by cascoPremium
    newOffers.forEach((o: any) => {
      if (!o.cascoPremium) {
        o.cascoPremium = 0;
      }
    });
    this.setState({ offers: newOffers });
    //console.log('loadOffers sort ------------------------------------------------------',);
    //console.log('loadOffers sort before',);
    newOffers.forEach((o: any) => {
      //console.log('loadOffers sort', o.id, o.cascoPremium, typeof o.cascoPremium);
    })
    //console.log('loadOffers sort ------------------------------------------------------',);
    //console.log('loadOffers sort after',);
    // const sorted = newOffers.sort((a, b) => {
    //   const cascoA = a.cascoPremium ? a.cascoPremium : 0;
    //   const cascoB = b.cascoPremium ? b.cascoPremium : 0;
    //   // //console.log('loadOffers sort',cascoA, cascoB, (cascoA) - (cascoB))
    //   return cascoA - cascoB
    // });

    const zeroOffers = newOffers.filter((o: any) => !o.cascoPremium || o.cascoPremium == 0);
    let notZeroOffers = newOffers.filter((o: any) => o.cascoPremium && o.cascoPremium > 0);

    notZeroOffers.sort((a, b) => {
      return (a.cascoPremium || 0) - (b.cascoPremium || 0);
    });
    // notZeroOffers.concat(zeroOffers);
    // newOffers.forEach((o: any) => {
    //   //console.log('loadOffers sort', o.id, o.cascoPremium, typeof o.cascoPremium);
    // })
    const newOfferList = [...notZeroOffers, ...zeroOffers];
    //console.log('loadOffers sort ------------------------------------------------------',);
    // 
    // Update the state immutably
    this.setState({ offers: [] }, () => {
      this.setState({ offers: newOfferList });
      // this.sortOffers('Casco');
      this.setState({ loadOffersBussy: false });
    });

    // await this.setState({loadOffersBussy: false});
  }




  sortOffers = async (colName?: string) => {
    let _offers = this.state.offers.filter(x => x != null);
    let sortField = this.state.sortField;
    let sortType = this.state.sortType;

    if (!colName) {
      colName = '';
    }

    await this.setState({ offers: [] });

    //console.log('sortOffers', _offers);

    if (colName === "Company") {

      if (sortField == "Company" && sortType == "Asc") {
        sortType = "Desc";
        _offers.sort((a, b) => {
          const companyNameA = (a.insuranceCompany && a.insuranceCompany.name) || '';
          const companyNameB = (b.insuranceCompany && b.insuranceCompany.name) || '';
          return companyNameB.localeCompare(companyNameA);
        });
      }
      else {
        sortType = "Asc";
        _offers.sort((a, b) => {
          const companyNameA = (a.insuranceCompany && a.insuranceCompany.name) || '';
          const companyNameB = (b.insuranceCompany && b.insuranceCompany.name) || '';
          return companyNameA.localeCompare(companyNameB);
        });
        sortField = "Company";
      }

    } else if (colName === "Route") {
      if (sortField == "Route" && sortType == "Asc") {
        sortType = "Desc";
        _offers.sort((a, b) => {
          return (a.routeId || 0) - (b.routeId || 0);

        });
      }
      else {
        sortType = "Asc";
        _offers.sort((a, b) => {
          return (b.routeId || 0) - (a.routeId || 0);
        });
      }

      sortField = "Route";

    } else if (colName === "Casco") {
      if (sortField == "Casco" && sortType == "Asc") {
        sortType = "Desc";
        _offers.sort((a, b) => {
          return (b.cascoPremium || 0) - (a.cascoPremium || 0);
        });


      }
      else {
        sortType = "Asc";
        _offers.sort((a, b) => {
          return (a.cascoPremium || 0) - (b.cascoPremium || 0);
        });
      }


      sortField = "Casco";

    }
    else if (colName === "Compulsory") {
      if (sortField == "Casco" && sortType == "Asc") {
        sortType = "Desc";
        _offers.sort((a, b) => {
          return (b.compulsoryPremium || 0) - (a.compulsoryPremium || 0);
        });


      }
      else {
        sortType = "Asc";
        _offers.sort((a, b) => {
          return (a.compulsoryPremium || 0) - (b.compulsoryPremium || 0);
        });
      }


      sortField = "Compulsory";


    }
    else if (colName === "Riders") {
      if (sortField == "Riders" && sortType == "Asc") {
        sortType = "Desc";
        _offers.sort((a, b) => {
          const sumA = (a.riderPackages || []).reduce((sum, x) => sum + ((x.autoActive === 0 && x.recommendedCost) || 0), 0);
          const sumB = (b.riderPackages || []).reduce((sum, x) => sum + ((x.autoActive === 0 && x.recommendedCost) || 0), 0);
          return sumB - sumA;
        });


      }
      else {
        sortType = "Asc";
        _offers.sort((a, b) => {
          const sumA = (a.riderPackages || []).reduce((sum, x) => sum + ((x.autoActive === 0 && x.recommendedCost) || 0), 0);
          const sumB = (b.riderPackages || []).reduce((sum, x) => sum + ((x.autoActive === 0 && x.recommendedCost) || 0), 0);
          return sumA - sumB;
        });
      }



      sortField = "Riders";

    }
    else if (colName === "Sum") {
      if (sortField == "Sum" && sortType == "Asc") {
        sortType = "Desc";
        _offers.sort((a, b) => {
          var sumA = (a.cascoPremium || 0) + (a.compulsoryPremium || 0);
          if (a.riderPackages != undefined && a.riderPackages.length > 0) {
            sumA += (a.riderPackages || []).reduce((sum, x) => sum + ((x.autoActive === 0 && x.recommendedCost) || 0), 0);
          }
          var sumB = (b.cascoPremium || 0) + (b.compulsoryPremium || 0);
          if (b.riderPackages != undefined && b.riderPackages.length > 0) {
            sumB += (b.riderPackages || []).reduce((sum, x) => sum + ((x.autoActive === 0 && x.recommendedCost) || 0), 0);
          }
          return sumB - sumA;
        });


      }
      else {
        sortType = "Asc";
        _offers.sort((a, b) => {
          var sumA = (a.cascoPremium || 0) + (a.compulsoryPremium || 0);
          if (a.riderPackages != undefined && a.riderPackages.length > 0) {
            sumA += (a.riderPackages || []).reduce((sum, x) => sum + ((x.autoActive === 0 && x.recommendedCost) || 0), 0);
          }
          var sumB = (b.cascoPremium || 0) + (b.compulsoryPremium || 0);
          if (b.riderPackages != undefined && b.riderPackages.length > 0) {
            sumB += (b.riderPackages || []).reduce((sum, x) => sum + ((x.autoActive === 0 && x.recommendedCost) || 0), 0);
          }
          return sumA - sumB;
        });
      }



      sortField = "Sum";

    }
    ////console.log('sortOffers', _offers);
    await this.setState({ offers: _offers });
    await this.setState({ sortField: sortField });
    await this.setState({ sortType: sortType });
  };

  startLoading = () => {
    this.setState({ loadingOffers: true });
    this.setState({ offers: [] });
  }

  stopLoading = () => {
    this.setState({ loadingOffers: false });
  }

  getSimulatorData = () => {
    if (this.sideBarRef != null && this.sideBarRef.current != null) {
      var simData = this.sideBarRef.current.getSimulatorData();
      simData.riders = this.state.riders;
      // //console.log('simData', simData);
      return simData;
    }
  }

  onLoggedUserChange(status: boolean) {
    this.setState({ userLogged: status });
  }

  render() {
    //console.log('simulator Props:', this.props);


    return (
      <div className="App">
        <LoginStatus onChange={(status: boolean) => this.onLoggedUserChange(status)} />
        {
          !this.state.userLogged && <LoginPopup />
        }
        {
          this.state.productionOffer ? <OfferProduction offer={this.state.productionOffer} riders={this.state.propductionRiders} closeProduction={this.closeProduction} showLog={this.showOfferLog} /> : ""
        }
        <div className={this.state.logData.length > 0 ? "popup-wrapper" : "popup-wrapper hide"}>
          <section className="popup-window rtl">
            <div onClick={() => this.clearOfferLog()} className="close-icon pointer"></div>
            <div className="popup-content">
              <div className="popup-header">
                <div className="popup-title">
                  לוג
                </div>
              </div>
              <div className="popup-body">
                {this.state.logData}
              </div>
              <div className="popup-footer">
                <button onClick={() => this.clearOfferLog()} className="button blue">
                  סגור
                </button>
                <button onClick={() => this.copyToClipboard()} className={this.state.copied ? "" : "button blue"}   >
                  העתק
                </button>
              </div>
            </div>
          </section>
        </div>
        <div className='main-content rtl'>
          <Menu activePage='Simulator' />
          {this.state.data ? (
            <div className='center-content'>
              <Header PageName="סימולטור" />
              <section className={this.state.filterOpen ? "main-body simulator show-side-form" : "main-body simulator"} >

                <div className="side-form-holder">
                  <div className="simulator-header-row" onClick={this.hideFilterClick.bind(this)}>
                    <div className="title-and-icon">
                      <div className="icon settings"></div>
                      <div className="title">מסננים</div>
                    </div>
                    <div className="icon arrow-right pointer" id="hide-simulator-btn"></div>
                  </div>

                  <SimulatorSidebar data={this.state.data} loadOffers={this.loadOffers} loadRiders={this.loadRiders} startLoading={this.startLoading} stopLoading={this.stopLoading} ref={this.sideBarRef} loadingOffers={this.state.loadingOffers} />


                </div>
                <div className="content-table simulator-content-table">
                  <div className="content-header">
                    <div className="flex-centered flex-space-between  mobile-only">
                      <div className="content-main-title">סימולטור</div>
                      <div className="actions flex-centered flex-space-between">
                        <div className="icon search"></div>
                        <div className="icon gear"></div>

                      </div>
                    </div>
                    <div className="flex-end desktop-only">
                      <div className="list-actions-row flex-centered flex-space-between">
                        <div className="">
                          <button type="button" id="show-simulator-btn" className="button big-btn blue has-icon pointer show-simulator-btn">
                            <div className="icon settings"></div>
                            <div className="title">מסננים</div>
                            <div className="icon arrow-left" onClick={this.hideFilterClick.bind(this)}></div>
                          </button>
                          <div className="user-details-row">
                            <div className="name">
                              {this.state.data != null && this.state.data.lead != null ? this.state.data.lead.firstName + " " + this.state.data.lead.lastName : ""}
                            </div>
                            <div className="phone">
                              {this.state.data != null && this.state.data.lead != null ? this.state.data.lead.phoneNumber1 : ""}
                            </div>
                            <div className="client-card-link">
                              כרטיס לקוח
                            </div>
                          </div>
                        </div>
                        <div className="filter-row flex-centered flex-space-between">
                          <div className="filter-input search">
                            <input type="text" placeholder="חיפוש" />
                            <div className="icon search"></div>
                          </div>
                          <div className="icon gear"></div>
                        </div>
                      </div>
                      <div className="content-table-header flex-space-between">
                        <div className="cell icon-cell"><div className="icon tag"></div></div>
                        <div className="cell companyNameCell status flex-centered flex-space-between" onClick={(e: any) => this.sortOffers("Company")}>
                          חברה
                          <div className="icon sort"></div>
                        </div>
                        <div className="cell nameCell" onClick={(e: any) => this.sortOffers("Route")}>מסלול</div>
                        <div className="cell long notes" onClick={(e: any) => this.sortOffers("Comments")}>הערות</div>
                        <div className="cell price" onClick={(e: any) => this.sortOffers("Casco")}>קסקו</div>
                        <div className="cell price" onClick={(e: any) => this.sortOffers("Compulsory")}>חובה</div>
                        <div className="cell price" onClick={(e: any) => this.sortOffers("Riders")}>ריידר</div>
                        <div className="cell last-cell" onClick={(e: any) => this.sortOffers("Sum")}>סה"כ</div>
                        {/* <div className='cell actions'></div> */}
                      </div>
                    </div>
                  </div>
                  <div className="content-body simulator-content">
                    {this.state.renewalOffer ?
                      <RenewalOffer
                        offer={this.state.renewalOffer}
                        riders={JSON.parse(JSON.stringify(this.state.renewalRiders))}
                        showOfferLog={this.showOfferLog}
                        getSimulatorData={this.getSimulatorData}
                        onChanged={this.updateOffer}
                        onProductionClick={this.openProduction}
                        selectedLeadId={this.selectedLeadId}
                        lead={this.state.data && this.state.data.lead ? this.state.data.lead : null}
                      ></RenewalOffer>
                      : ""}
                    {/* {this.state.loadingOffers?

                          <div style={{textAlign: 'center'}}><Spin size="large" /><p>טוען נתונים...</p> </div> :<></>
                        } */}
                    {this.state.loadingOffers === false && this.state.offers && this.state.offers.length > 0 ? this.state.offers.map((offer: SimulatorOfferModel) => {
                      return (
                        <>
                          <Offer
                            offer={offer}
                            riders={JSON.parse(JSON.stringify(this.state.riders))}
                            showOfferLog={this.showOfferLog}
                            getSimulatorData={this.getSimulatorData}
                            onChanged={this.updateOffer}
                            onProductionClick={this.openProduction}
                            selectedLeadId={this.selectedLeadId}
                            lead={this.state.data && this.state.data.lead ? this.state.data.lead : null}
                          ></Offer>
                        </>
                      )
                    }) : this.state.loadingOffers ?
                        <div style={{textAlign: 'center', fontSize: 20, marginTop: 20}}><Spin size="large" /><p>אנא המתן, המערכת טוענת הצעות</p> </div>

                      // <PleaseWaitLayer />

                      // <div style={{textAlign: 'center'}}><Spin size="large" /></div>
                      :
                      <div className='noResultsDiv'>
                        <div className='noResultsAllText'>
                          <div className="noResultsTitle">אין מספיק נתונים</div>
                          <div className="noResultsText">
                            כדי שנוכל למצוא עבורך הצעות מתאימות, מלא את הפרטים בחלק הימני ולחץ על "הצג הצעות"
                          </div>
                        </div>
                      </div>}



                  </div>
                </div>

              </section>
            </div>
          ) : (
            <></>
          )}
        </div>


      </div>
    );
  }
}


